import * as z from 'zod';

export const aggregationType = z.enum(['product_location', 'sku_location']);

export type AggregationType = z.infer<typeof aggregationType>;
